import { gql } from "@apollo/client";

export const CASH_REFUNDS_QUERY = gql`
  query cash_refund_requests($where: cashless_refund_requests_bool_exp) {
    cashless_refund_requests(where: $where, order_by: { created_at: desc }, limit: 1000) {
      id
      guid
      event_id
      uid
      status
      amount
      gross_amount
      fee_amount
      balance_before
      hold_applied
      balance_restored
      needs_manual_fix
      failure_reason
      recipient_name
      recipient_email
      recipient_phone
      delivery_method
      phone_verified
      provider
      bank_account_last4
      bank_account_type
      ach_batch_id
      delivery_status
      delivery_checked_at
      request_ip
      created_at
      updated_at
      completed_at
      event {
        id
        name
      }
    }
  }
`;

/** Totals for the header, so ops can see exposure without adding up the grid. */
export const CASH_REFUND_TOTALS_QUERY = gql`
  query cash_refund_totals($where: cashless_refund_requests_bool_exp) {
    cashless_refund_requests_aggregate(where: $where) {
      aggregate {
        count
        sum { amount }
      }
    }
  }
`;
